import { useAppSelector } from "..";

export function useOrganizationSelector() {
  return useAppSelector(({ organizations }) => organizations.organizations);
}

export function useArchiveBooksSelector() {
  return useAppSelector(({ organizations }) => organizations.archiveBooks);
}
